import { render } from "./taxPaySz.vue?vue&type=template&id=a01f481c&scoped=true"
import script from "./taxPaySz.vue?vue&type=script&lang=js"
export * from "./taxPaySz.vue?vue&type=script&lang=js"

import "./taxPaySz.vue?vue&type=style&index=0&id=a01f481c&lang=less&scoped=true"
import "./taxPaySz.vue?vue&type=style&index=1&id=a01f481c&lang=scss"

import exportComponent from "/var/jenkins_home/workspace/edu-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a01f481c"]])

export default __exports__